export const DEVICE_OPTIONS = ['desktop', 'mobile', 'all'];
